import React from 'react';
import {Link} from 'react-router-dom';

function AcademicHeroTabs({ selectedTab }) {
  return (
    <div className="container academic" id="hero-tabs-container">
      <div className={selectedTab === 'stem' ? 'hero-tab-first hero-tab-selected' : 'hero-tab-first'}>
        <Link to='/vocational/steam'/>
        <p>STEAM for Vocational </p>
      </div>
      <div className={selectedTab === 'product' ? 'hero-tab hero-tab-selected' : 'hero-tab'}>
        <Link to='/vocational/product-service'/>
        <p>Product & Services</p>
      </div>
      <div className={selectedTab === 'curriculum' ? 'hero-tab hero-tab-selected' : 'hero-tab'}>
        <Link to='/vocational/curriculum'/>
        <p>Curriculum</p>
      </div>
      <div className={selectedTab === 'demo' ? 'hero-tab-last hero-tab-selected' : 'hero-tab-last'}>
        <Link to='/vocational/demo'/>
        <p>Get Demo Product</p>
      </div>
      {/* <div className='hero-tab-last'>
        <Link to='#'/>
        <p>Standards</p>
      </div> */}
  </div>
  )
}

export default  AcademicHeroTabs;